export default __webpack_public_path__ + "media/images/brands/demo/logos/email_logo-1f770d174f28030395616c3586130b8f.png";